import React
//,
 //{ 
  //useEffect, 
 // useMemo, 
 // useRef } 
  from "react";
//import { useSelector } from "react-redux";
//import { Chart } from "chart.js";
//import { metronic } from "../../_metronic";
import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid'
import listPlugin from '@fullcalendar/list';
import interactionPlugin, {Draggable} from "@fullcalendar/interaction";
import '../pages/home/main.scss' // webpack must be configured to do this
import '../pages/home/main.css' // webpack must be configured to do this

import { getSchedules,getSchedulesById,completeTask,getStatus,getScheduleByPatient,updateSchedule } from "../crud/auth.crud";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import ReactTooltip from 'react-tooltip';
import EditSchedule from '../pages/home/EditSchedule';
import { Table } from "react-bootstrap";
import {  format } from 'date-fns'

                                                    


export default class CalendarEvents extends React.Component {


  
  
constructor(props)
{
  super(props);

  let type = 'calender';
  if(props.type!=null)
  {
    console.log("props calender::::",props.type);
    type = props.type;
  }
  
  this.state = {
      schedules:[],
      open:false,
      notes:"",
      pEntityId:"",
      type:type,
    };

 
  
}



handleEventClick = ({ event, el }) => {
        //this.toggle();
        console.log(event);
        //console.log(this.state.schedule.title);
         getSchedulesById(event.id).then(response => response.data)
    .then((data) => {
      this.setState({ open:true, schedule: data[0],tStatus: data[0].status,notes: data[0].notes});
     
     })

      };

      rowClick = (id) => {
        //this.toggle();
        console.log(id);
        //console.log(this.state.schedule.title);
         getSchedulesById(id).then(response => response.data)
    .then((data) => {
      this.setState({ open:true, schedule: data[0],tStatus: data[0].status,notes: data[0].notes});
     
     })

      };

eventRender(info){
    
  }

  handleEventPositioned(info) {
  info.el.setAttribute("data-tip",info.event.extendedProps.description);
   ReactTooltip.rebuild();
 }

filterByStatus= (statusId) => {

  let tempSchedules=[];
  if(statusId!=null)
  {
    getScheduleByPatient(this.state.pEntityId).then(response => response.data)
    .then((data) => {
      
      //console.log(this.state.users)
      data.filter(f=> f.statusKey == statusId).map((sch)=>(
          tempSchedules.push({id: sch.id, title: this.props.name, date: sch.startDate, backgroundColor: sch.status,description: sch.scheduleType, borderColor: sch.status, textColor:'white',key:sch.scheduleId})
        ))
      this.setState({ schedules: tempSchedules });
      //console.log("didmount");
      //console.log(this.state.schedules);
     })
  }
  else
  {

    getScheduleByPatient(this.state.pEntityId).then(response => response.data)
    .then((data) => {
      
      //console.log(this.state.users)
      data.map((sch)=>(
          tempSchedules.push({id: sch.id, title: this.props.name, date: sch.startDate, backgroundColor: sch.status,description: sch.scheduleType, borderColor: sch.status, textColor:'white',key:sch.scheduleId})
        ))
      this.setState({ schedules: tempSchedules });
      //console.log("didmount");
      //console.log(this.state.schedules);
     })
  }

}
  
componentDidMount()
  {
    //let schedules = this.state.schedules;

      let tempSchedules=[];
   
    if(this.props.pEntityId != null)
    {
      console.log("pEntity==="+this.props.pEntityId);
      this.state.pEntityId = this.props.pEntityId;
      getScheduleByPatient(this.props.pEntityId).then(response => response.data)
      .then((data) => {
        console.log("calender:::",data);
        data.map((sch)=>(
            tempSchedules.push({id: sch.id,title: this.props.name, date: sch.startDate, backgroundColor: sch.status,description: sch.scheduleType, borderColor: sch.status, textColor:'white',key:sch.scheduleId})
          ))
        this.setState({ schedules: tempSchedules });
       });
    

      getStatus().then(response => response.data)
      .then((data) => {
        this.setState({ mStatus: data })
       // console.log(data);
       });
    }
  }

  handleClose = () =>
  {
    let tempSchedules=[];
    this.setState({open:false});
    getScheduleByPatient(this.props.pEntityId).then(response => response.data)
      .then((data) => {
        //console.log(this.state.users)
        data.map((sch)=>(
            tempSchedules.push({id: sch.id,title: this.props.name, date: sch.startDate, backgroundColor: sch.status,description: sch.scheduleType, borderColor: sch.status, textColor:'white',key:sch.scheduleId})
          ))
        this.setState({ schedules: tempSchedules });
       });
  }
drop = info => 
      {
        alert(info.draggedEl.id);
      }

  eventDrop = info =>
      {
        const string = info.event.title;
        let scheduleKey='';
        //const stringId = string.split(' - ')[0];
        const id = info.event.id;
        console.log(string+ "------" + id + "======" + info.event.start);
         this.state.schedules.filter(f=> f.id == id).map((sch)=>(
          scheduleKey = sch.key
          ))
        let schedule = {
                     
                      startDate:info.event.start
                      
                     
                   };
                    updateSchedule("schedule",scheduleKey,schedule
                      )
                      .then(resp => {
                        //props.register(accessToken);
                      })
                      .catch(() => {
                      });

        //this.props.schedulesEvent(id, info.event.start, info.event.end)
      };

  completeSchedule = () =>
  {
     this.state.schedule.status=this.state.tStatus;
     //this.state.schedule.percentage = 100;
     this.state.schedule.notes  = this.state.notes;
     if(this.state.tStatus=="green")
     {
        this.state.schedule.percentage = 100;
     }
     else if(this.state.tStatus=="red")
     {
        this.state.schedule.percentage = 0;
     }
      
      completeTask(this.state.schedule).then(response => response.data)
      .then((data) => {
        
                let tempSchedules=[];
                getSchedules().then(response => response.data)
                .then((data) => {
                  
                  //console.log(this.state.users)
                  data.map((sch)=>(
                      tempSchedules.push({id: sch.id, title: this.props.name, date: sch.startDate, backgroundColor: sch.status,description: sch.scheduleType, borderColor: sch.status, textColor:'white',key:sch.scheduleId})
                    ))
                  this.setState({ schedules: tempSchedules,open:false });
                  //console.log("didmount");
                  //console.log(this.state.schedules);
                 })

      })
     
  }

  undoSchedule = () =>
  {
     this.state.schedule.status="red";
     this.state.schedule.percentage = 0;
     this.state.schedule.notes  = this.state.notes;
      
      completeTask(this.state.schedule).then(response => response.data)
      .then((data) => {
        
          let tempSchedules=[];
                getSchedules().then(response => response.data)
                .then((data) => {
                  
                  //console.log(this.state.users)
                  data.map((sch)=>(
                      tempSchedules.push({id: sch.id, title: this.props.name, date: sch.startDate, backgroundColor: sch.status,description: sch.scheduleType, borderColor: sch.status, textColor:'white',key:sch.scheduleId})
                    ))
                  this.setState({ schedules: tempSchedules,open:false });
                  //console.log("didmount");
                  //console.log(this.state.schedules);
                 })

      })
     
  }



  render()
  {
    //console.log("render");
    //console.log(this.state.schedules);
    console.log("open status=="+this.state.open);
    return (
      <div className="kt-portlet kt-portlet--height-fluid">
          {/*<div className="kt-portlet__head">
            <div className="kt-portlet__head-label">
              <h3 className="kt-portlet__head-title">Patient Status</h3>
            </div>
          </div>*/}
          <div className="kt-portlet__body">
            <div className="row">
                {this.state.mStatus!=null && this.state.mStatus.map((status)=>(
                  
                  <div className="btn-toolbar kt-margin-l-20">
                      <div className="dropdown" id="kt_subheader_group_actions_status_change">
                      <button onClick={()=>this.filterByStatus(status.statusKey)} className="btn btn-success btn-elevate btn-pill btn-sm" style={{background: status.statusId, 'border-color':status.statusId}}>
                        {status.statusName}
                      </button></div>
                  </div>
                
                  ))}
                
                  <div className="btn-toolbar kt-margin-l-20">
                      <div className="dropdown text-nowrap" id="kt_subheader_group_actions_status_change">
                      <button onClick={()=>this.filterByStatus(null)} className="btn btn-success btn-pill btn-sm" style={{background:'#2c3e50','border-color':'#2c3e50'}} >
                        Show All
                      </button></div>
                  </div>
                
            </div>

            <div className="kt-space-20" />
            <div className="row"> 
                {this.state.type === 'calendar' &&
                <FullCalendar style={{width:'100%'}} defaultView="dayGridMonth" header={{
                  left: "today prev,next",
                  center: "title",
                  right: "dayGridDay,dayGridWeek,dayGridMonth,listYear",

                  }} 
                  buttonText={{
                      today:    'Today',
                      month:    'Month',
                      week:     'Week',
                      day:      'Day',
                      list:     'Year'
                    }}  plugins={[ dayGridPlugin,listPlugin,interactionPlugin ]} events={this.state.schedules} 
                  eventClick={this.handleEventClick}
                  eventPositioned={this.handleEventPositioned}
                   editable={true}
                      selectable={true}
                      displayEventTime={false}
                      dayMaxEvents={true}
                  drop={this.drop}
                  eventDrop={this.eventDrop}
                  />
                }
             {this.state.type === 'list' &&
              <Table striped bordered hover>
                   <thead>
                    <tr>
                      
                      <th>Name</th>
                      <th>Due date</th>
                      <th>Status</th>
                     
                      
                    </tr>
                  </thead>
                  <tbody>
                {this.state.schedules.map((sch)=>(
                <tr onClick={()=>this.rowClick(sch.id)}>
                     
                      <td>{sch.title}</td>
                      <td>{format(new Date(sch.date), 'MM/dd/yyyy')}</td>
                      <td>
                        
                              <button className="btn btn-success btn-elevate btn-pill btn-sm" style={{background: sch.backgroundColor, 'border-color':sch.backgroundColor}}>
                                {this.state.mStatus!=null && this.state.mStatus.filter(x=>x.statusId === sch.backgroundColor).map((status) =>(
                                  status.statusName
                                  ))}
                              </button>
                         
                      </td>
                </tr>


              ))}
              </tbody>
              </Table>

            }
        </div>

        </div>
         {this.state.schedule != null &&
        <Dialog open={this.state.open} onClose={this.handleClose} aria-labelledby="form-dialog-title">
        
        {this.state.schedule.pEntity.map((pen)=> (
          <>

        <DialogTitle id="form-dialog-title">{pen.firstName + " " + pen.lastName} - {this.state.schedule.scheduleType}</DialogTitle>
        <DialogContent>
          <EditSchedule schedule={this.state.schedule} />
        </DialogContent>
      

        <DialogActions>
          <Button onClick={this.handleClose} color="primary">
            Cancel
          </Button>
          
        </DialogActions>
          </>
        ))}
      </Dialog>
    }
      </div>
       
    );
  }
}
